<template>
	<div class="main">
		<!-- start: page -->
		<section class="panel panel-default">
			<header class="panel-heading">
				<div class="panel-actions">
                    <a href="javascript:;" @click="currentEdit(1)" v-if="isAdmin('stay')">編輯</a>
					<a href="#privacy" data-toggle="collapse" class="panel-action panel-action-toggle" @click="isViewPrivacy = true" v-if="$route.name != `stay.apply.treaty.edit`"></a>
				</div>
        <h1 v-show="!isEditPrivacy" class="panel-title">{{ model.PolicyAnnounce.title }} 第{{ model.PolicyAnnounce.version }}版</h1>
        <div v-show="isEditPrivacy" class="form-group">
          <label for="title">標題</label>
          <div>
            <input id="title" name="title" v-model="model.PolicyAnnounce.title" type="text" class="form-control"/>
          </div>
          <label for="title">版本</label>
          <div>
            <input id="version" name="version" v-model="model.PolicyAnnounce.version" type="text" class="form-control"/>
          </div>
        </div>
			</header>
			<div id="privacy" :class="$route.name != `stay.apply.treaty.edit` ? `panel-collapse collapse`:``">
				<div class="panel-body" v-html="model.PolicyAnnounce.content" v-if="!isEditPrivacy"></div>
        <ckeditor v-model="model.PolicyAnnounce.content" :config="editorConfig" v-else></ckeditor>
			</div>
			<footer class="panel-footer" v-show="isViewPrivacy" v-if="this.$route.name != `stay.apply.treaty.edit`">
				<label class="s_agr">
					<input type="checkbox" v-validate="'required'" name="privacyCheckBox" v-model="privacyCheckBox">
					我同意以上{{model.PolicyAnnounce.title}}
				</label>
				<span class="text-danger" v-show="errors.has('privacyCheckBox')">{{ errors.first('privacyCheckBox') }}</span>
			</footer>
		</section>
		<section class="panel panel-default">
			<header class="panel-heading">
				<div class="panel-actions">
                    <a href="javascript:;" @click="currentEdit(2)" v-if="isAdmin('stay')">編輯</a>
					<a href="#stayOffice" data-toggle="collapse" class="panel-action panel-action-toggle" @click="isViewStayOffice = true" v-if="$route.name != `stay.apply.treaty.edit`"></a>
				</div>
        <h1 v-show="!isEditStayOffice" class="panel-title">{{ model.ManageMethod.title }}</h1>
        <div v-show="isEditStayOffice" class="form-group">
          <label for="title">標題</label>
          <div>
            <input id="title" name="title" v-model="model.ManageMethod.title" type="text" class="form-control"/>
          </div>
        </div>
			</header>
			<div id="stayOffice" :class="$route.name != `stay.apply.treaty.edit` ? `panel-collapse collapse`:``">
				<div class="panel-body" v-html="model.ManageMethod.content" v-if="!isEditStayOffice"></div>
        <ckeditor v-model="model.ManageMethod.content" :config="editorConfig" v-else></ckeditor>
			</div>
			<footer class="panel-footer" v-show="isViewStayOffice" v-if="this.$route.name != `stay.apply.treaty.edit`">
				<label class="s_agr">
					<input type="checkbox" v-validate="'required'" name="stayOfficeCheckBox" v-model="stayOfficeCheckBox"> 我同意以上{{model.ManageMethod.title}}
				</label>
				<span class="text-danger" v-show="errors.has('stayOfficeCheckBox')">{{ errors.first('stayOfficeCheckBox') }}</span>
			</footer>
		</section>
		<div class="panel panel-default">
			<header class="panel-heading">
				<div class="panel-actions">
                    <a href="javascript:;" @click="currentEdit(3)" v-if="isAdmin('stay')">編輯</a>
					<a href="#lifeConvention" data-toggle="collapse" class="panel-action panel-action-toggle" @click="isViewLifeConvention =true;" v-if="$route.name != `stay.apply.treaty.edit`"></a>
				</div>
        <h1 v-show="!isEditLifeConvention" class="panel-title">{{ model.Convention.title }}</h1>
        <div v-show="isEditLifeConvention" class="form-group">
          <label for="title">標題</label>
          <div>
            <input id="title" name="title" v-model="model.Convention.title" type="text" class="form-control"/>
          </div>
        </div>
			</header>
			<div id="lifeConvention" :class="$route.name != `stay.apply.treaty.edit` ? `panel-collapse collapse`:``">
				<div class="panel-body" v-html="model.Convention.content" v-if="!isEditLifeConvention"></div>
        <ckeditor v-model="model.Convention.content" :config="editorConfig" v-else></ckeditor>
			</div>
			<footer class="panel-footer" v-show="isViewLifeConvention" v-if="$route.name != `stay.apply.treaty.edit`">
				<label class="s_agr">
					<input type="checkbox" v-validate="'required'" name="lifeConventionCheckBox" v-model="lifeConventionCheckBox"> 我同意以上並遵守生活公約
				</label>
				<span class="text-danger" v-show="errors.has('lifeConventionCheckBox')">{{ errors.first('lifeConventionCheckBox') }}</span>
			</footer>
		</div>
		<div class="col-md-12">
			<div class="s_tenc" v-if="$route.name != `stay.apply.treaty.edit`">
				<a @click="nextClick" class="btn-upload btn s_btn_b">下一步</a>
			</div>
            <div class="s_tenc" v-if="$route.name == `stay.apply.treaty.edit`">
				<a @click="saveClick" class="btn-upload btn s_btn_b">儲存</a>
			</div>
		</div>
	</div>
</template>

<script>
import CKEditor from "@/ckeditor4";
export default {
    components: {
		ckeditor: CKEditor.component
	},
	data() {
		return {
			privacyCheckBox: false,
			stayOfficeCheckBox: false,
			lifeConventionCheckBox: false,
			isViewPrivacy:false,
			isViewStayOffice:false,
			isViewLifeConvention:false,
      isEditPrivacy:false,
      isEditStayOffice:false,
      isEditLifeConvention:false,
      model:{
          PolicyAnnounce:{},
          ManageMethod:{},
          Convention:{}
      },
      editorConfig: {
				extraPlugins: ["colorbutton"],
				height:500,
				toolbar: [
					["Source"],
					["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
					["Undo", "Redo"],
					["RemoveFormat"],
					["NumberedList", "BulletedList"],
					["Outdent", "Indent"],
					["Blockquote"],
					["Link", "Unlink", "Anchor"],
					["Table", "HorizontalRule"],
					["SpecialChar"],
					"/",
					["Styles", "Format"],
					["Bold", "Italic", "Strike"],
					["TextColor", "BGColor"],
					["Maximize"],
					["About"]
				]
			},
		}
	},
	created() {
        const ApiFunc = async ()=>{
            return await this.$axios.get(`/api/Common/treaty?type=room`, "");
        }
        Promise.all([ApiFunc()]).then(results => {
            const a = results[0];
            this.model = a.data;
            this.model.PolicyAnnounce.content = this.htmlDecode(this.model.PolicyAnnounce.content);
            this.model.ManageMethod.content = this.htmlDecode(this.model.ManageMethod.content);
            this.model.Convention.content = this.htmlDecode(this.model.Convention.content);
        });
	},
	methods: {
		nextClick() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.$parent.goView();
				} else {
					bootbox.alert("請確認條約是否有打勾")
				}
			});
		},
    saveClick(){
        let errorMsgs =[];
        if(!this.model.PolicyAnnounce.content){
            errorMsgs.push("請填寫隱私權及個人資料保護政策宣告");
        }
        if(!this.model.ManageMethod.content){
            errorMsgs.push("請填寫亞東學校財團法人亞東科技大學學生住宿輔導及管理辦法");
        }
        if(!this.model.Convention.content){
            errorMsgs.push("請填寫亞東學校財團法人亞東科技大學學生宿舍生活公約");
        }
        if(errorMsgs.length > 0){
            bootbox.alert(errorMsgs.join("<br/>"));
            return false;
        }
        const formData = new FormData();
        formData.append("treaty", JSON.stringify({
            PolicyAnnounce:{
                title:this.model.PolicyAnnounce.title,
                version:this.model.PolicyAnnounce.version,
                content:this.htmlEncode(this.model.PolicyAnnounce.content)
            },
            ManageMethod:{
                title:this.model.ManageMethod.title,
                content:this.htmlEncode(this.model.ManageMethod.content)
            },
            Convention:{
                title:this.model.Convention.title,
                content:this.htmlEncode(this.model.Convention.content)
            }
        }));
        formData.append("type", "room");
        const _this = this;
        this.$axios.post(`/api/Common/saveTreaty`, formData).then(resp => {
            bootbox.alert(resp.data.msg, function(){
                if(resp.data.status == "success"){
                    _this.$router.go(-1);
                }
            });
        });
    },
    currentEdit(treaty) {
      switch (treaty) {
        case 1:
          this.isEditPrivacy = !this.isEditPrivacy;
          this.isEditLifeConvention = false;
          this.isEditStayOffice = false;
          break;
        case 2:
          this.isEditPrivacy = false;
          this.isEditLifeConvention = false;
          this.isEditStayOffice = !this.isEditStayOffice;
          break;
        case 3:
          this.isEditPrivacy = false;
          this.isEditLifeConvention = !this.isEditLifeConvention;
          this.isEditStayOffice = false;
      }
    }
	}
}
</script>
